import React, { useState } from "react";
import logo from "../assets/images/logo.svg";
import { Link } from "react-router-dom";
import useMainMenu from "../MainMenu/useMainMenu";
import LegalsModal from "../shared/LegalsModal";
const Footer = () => {
  const { fns } = useMainMenu();
  const [isModal, setIsModal] = useState(false);
  const [modalInfo, setModalInfo] = useState({ link: "", title: "" });

  const handleModal = (e) => {
    e.preventDefault();
    let link = e.target.href;
    let title = e.target.title;
    setModalInfo({ link, title });
    setIsModal(true);
  };

  return (
    <div className="Footer">
      <div className="circle circle-1"></div>
      <div className="circle circle-2"></div>
      <div className="col-1 col ">
        <img src={logo} alt="Kamunity, Inc log" />
        <h2>Kamunity.io</h2>

        <p>
          The one-stop-shop for all <br /> consumer convenience
        </p>

        <ul>
          <li>
            <Link
              to="https://www.facebook.com/profile.php?id=100093866144215"
              target="_blank"
            >
              <svg
                width="20"
                height="21"
                viewBox="0 0 20 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20 10.5601C20 5.04006 15.52 0.560059 10 0.560059C4.48 0.560059 0 5.04006 0 10.5601C0 15.4001 3.44 19.4301 8 20.3601V13.5601H6V10.5601H8V8.06006C8 6.13006 9.57 4.56006 11.5 4.56006H14V7.56006H12C11.45 7.56006 11 8.01006 11 8.56006V10.5601H14V13.5601H11V20.5101C16.05 20.0101 20 15.7501 20 10.5601Z"
                  fill="#A4379E"
                />
              </svg>
            </Link>
          </li>
          <li>
            <Link to="https://twitter.com/kamunity_io" target="_blank">
              <svg
                width="21"
                height="22"
                viewBox="0 0 21 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.5 0.0600586C4.70156 0.0600586 0 4.76162 0 10.5601C0 16.3585 4.70156 21.0601 10.5 21.0601C16.2984 21.0601 21 16.3585 21 10.5601C21 4.76162 16.2984 0.0600586 10.5 0.0600586ZM15.5461 7.9749C15.5531 8.08506 15.5531 8.1999 15.5531 8.3124C15.5531 11.753 12.9328 15.7163 8.14453 15.7163C6.66797 15.7163 5.29922 15.2874 4.14609 14.5491C4.35703 14.5726 4.55859 14.5819 4.77422 14.5819C5.99297 14.5819 7.11328 14.1694 8.00625 13.471C6.8625 13.4476 5.90156 12.6976 5.57344 11.6663C5.97422 11.7249 6.33516 11.7249 6.74766 11.6194C6.15873 11.4998 5.62939 11.1799 5.24957 10.7142C4.86974 10.2485 4.66286 9.6657 4.66406 9.06475V9.03193C5.00859 9.22646 5.41406 9.346 5.83828 9.3624C5.48166 9.12473 5.1892 8.80274 4.98682 8.42497C4.78445 8.0472 4.67841 7.62534 4.67813 7.19678C4.67813 6.71162 4.80469 6.26865 5.03203 5.88428C5.68571 6.68897 6.5014 7.34711 7.42609 7.81592C8.35078 8.28472 9.36377 8.5537 10.3992 8.60537C10.0312 6.83584 11.3531 5.40381 12.9422 5.40381C13.6922 5.40381 14.3672 5.71787 14.843 6.22412C15.4312 6.11397 15.9937 5.89365 16.4953 5.59834C16.3008 6.20068 15.893 6.70928 15.3516 7.03037C15.8766 6.97412 16.3828 6.82881 16.8516 6.6249C16.4977 7.14522 16.0547 7.60693 15.5461 7.9749Z"
                  fill="#A4379E"
                />
              </svg>
            </Link>
          </li>
          <li>
            <Link
              to="https://www.linkedin.com/company/kamunity-io/"
              target="_blank"
            >
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.56 0C4.7278 0 0 4.7278 0 10.56C0 16.3922 4.7278 21.12 10.56 21.12C16.3922 21.12 21.12 16.3922 21.12 10.56C21.12 4.7278 16.3922 0 10.56 0ZM7.975 14.9369H5.8366V8.0553H7.975V14.9369ZM6.8926 7.2105C6.2172 7.2105 5.7805 6.732 5.7805 6.1402C5.7805 5.5363 6.2304 5.0721 6.9201 5.0721C7.6098 5.0721 8.0322 5.5363 8.0454 6.1402C8.0454 6.732 7.6098 7.2105 6.8926 7.2105ZM15.785 14.9369H13.6466V11.1232C13.6466 10.2355 13.3364 9.6327 12.5631 9.6327C11.9724 9.6327 11.6215 10.0408 11.4664 10.4335C11.4092 10.5732 11.3949 10.7712 11.3949 10.9681V14.9358H9.2554V10.2498C9.2554 9.3907 9.2279 8.6724 9.1993 8.0542H11.0572L11.1551 9.0101H11.198C11.4796 8.5613 12.1693 7.8991 13.3232 7.8991C14.7301 7.8991 15.785 8.8418 15.785 10.868V14.9369Z"
                  fill="#A4379E"
                />
              </svg>
            </Link>
          </li>
          <li>
            <Link to="https://www.instagram.com/Kamunity.io/" target="_blank">
              <svg
                width="20"
                height="21"
                viewBox="0 0 20 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.0286 0.561289C11.7583 0.558489 12.488 0.565823 13.2176 0.583289L13.4116 0.590289C13.6356 0.598289 13.8566 0.608289 14.1236 0.620289C15.1876 0.670289 15.9136 0.838289 16.5506 1.08529C17.2106 1.33929 17.7666 1.68329 18.3226 2.23929C18.831 2.7389 19.2244 3.34324 19.4756 4.01029C19.7226 4.64729 19.8906 5.37429 19.9406 6.43829C19.9526 6.70429 19.9626 6.92629 19.9706 7.15029L19.9766 7.34429C19.9943 8.07348 20.002 8.80289 19.9996 9.53229L20.0006 10.2783V11.5883C20.003 12.318 19.9954 13.0478 19.9776 13.7773L19.9716 13.9713C19.9636 14.1953 19.9536 14.4163 19.9416 14.6833C19.8916 15.7473 19.7216 16.4733 19.4756 17.1103C19.2252 17.778 18.8317 18.3829 18.3226 18.8823C17.8225 19.3906 17.2179 19.784 16.5506 20.0353C15.9136 20.2823 15.1876 20.4503 14.1236 20.5003C13.8566 20.5123 13.6356 20.5223 13.4116 20.5303L13.2176 20.5363C12.4881 20.5541 11.7583 20.5617 11.0286 20.5593L10.2826 20.5603H8.97358C8.24384 20.5628 7.5141 20.5551 6.78458 20.5373L6.59058 20.5313C6.35319 20.5227 6.11585 20.5127 5.87858 20.5013C4.81458 20.4513 4.08858 20.2813 3.45058 20.0353C2.78326 19.7846 2.17881 19.3911 1.67958 18.8823C1.17062 18.3826 0.776801 17.7778 0.525577 17.1103C0.278577 16.4733 0.110577 15.7473 0.0605769 14.6833C0.0494399 14.446 0.0394398 14.2087 0.030577 13.9713L0.0255771 13.7773C0.00714068 13.0478 -0.00119355 12.318 0.000577001 11.5883V9.53229C-0.00221397 8.80289 0.00512015 8.07349 0.0225771 7.34429L0.029577 7.15029C0.037577 6.92629 0.047577 6.70429 0.059577 6.43829C0.109577 5.37329 0.277577 4.64829 0.524577 4.01029C0.77595 3.34291 1.17054 2.73873 1.68058 2.24029C2.17947 1.73104 2.78354 1.33686 3.45058 1.08529C4.08858 0.838289 4.81358 0.670289 5.87858 0.620289L6.59058 0.590289L6.78458 0.585289C7.51376 0.566862 8.24316 0.558528 8.97258 0.560289L11.0286 0.561289ZM10.0006 5.56129C9.33808 5.55192 8.68033 5.67431 8.06555 5.92136C7.45077 6.1684 6.89122 6.53517 6.41942 7.00034C5.94762 7.46552 5.57298 8.01983 5.31726 8.63105C5.06155 9.24228 4.92987 9.89823 4.92987 10.5608C4.92987 11.2233 5.06155 11.8793 5.31726 12.4905C5.57298 13.1018 5.94762 13.6561 6.41942 14.1212C6.89122 14.5864 7.45077 14.9532 8.06555 15.2002C8.68033 15.4473 9.33808 15.5697 10.0006 15.5603C11.3267 15.5603 12.5984 15.0335 13.5361 14.0958C14.4738 13.1581 15.0006 11.8864 15.0006 10.5603C15.0006 9.23421 14.4738 7.96244 13.5361 7.02476C12.5984 6.08707 11.3267 5.56129 10.0006 5.56129ZM10.0006 7.56129C10.3991 7.55395 10.7951 7.62609 11.1654 7.7735C11.5357 7.92091 11.8729 8.14063 12.1574 8.41983C12.4418 8.69904 12.6678 9.03212 12.822 9.39963C12.9763 9.76714 13.0558 10.1617 13.0558 10.5603C13.0559 10.9589 12.9766 11.3534 12.8224 11.721C12.6683 12.0886 12.4424 12.4217 12.1581 12.701C11.8737 12.9803 11.5366 13.2002 11.1663 13.3477C10.796 13.4952 10.4001 13.5675 10.0016 13.5603C9.20593 13.5603 8.44287 13.2442 7.88026 12.6816C7.31765 12.119 7.00158 11.3559 7.00158 10.5603C7.00158 9.76464 7.31765 9.00158 7.88026 8.43897C8.44287 7.87636 9.20593 7.56029 10.0016 7.56029L10.0006 7.56129ZM15.2506 4.06129C14.928 4.0742 14.6229 4.21144 14.3992 4.44426C14.1755 4.67708 14.0506 4.98742 14.0506 5.31029C14.0506 5.63315 14.1755 5.9435 14.3992 6.17632C14.6229 6.40914 14.928 6.54638 15.2506 6.55929C15.5821 6.55929 15.9 6.42759 16.1345 6.19317C16.3689 5.95875 16.5006 5.64081 16.5006 5.30929C16.5006 4.97777 16.3689 4.65983 16.1345 4.42541C15.9 4.19099 15.5821 4.05929 15.2506 4.05929V4.06129Z"
                  fill="#A4379E"
                />
              </svg>
            </Link>
          </li>
        </ul>
      </div>
      {/* <iframe title="check" src="https://app.termly.io/document/privacy-policy/71e89487-cfbd-46c1-be56-3ec32d89d92f" frameborder="0"></iframe> */}
      {/* <div className="col col-2">
        <h2>Features</h2>
        <Link to="/">Transactions</Link>
        <Link to="/">Holdings</Link>
        <Link to="/">Insights</Link>
        <Link to="/">Forums </Link>
        <Link to="/">Offers</Link>
      </div> */}
      {/* <div className="col col-2">
        <h2>Legal</h2>
        <Link
          onClick={handleModal}
          title="terms"
          target="_blank"
          to="https://app.termly.io/document/terms-of-service/0da5d65f-5a2d-4425-9e15-cd6e6a20bf68"
        >
          Terms & Conditions
        </Link>
        <Link
          onClick={handleModal}
          title="privacy"
          target="_blank"
          to="https://app.termly.io/document/privacy-policy/71e89487-cfbd-46c1-be56-3ec32d89d92f"
        >
          Privacy Policy
        </Link>
        <Link
          onClick={handleModal}
          title="cookie"
          target="_blank"
          to="https://app.termly.io/document/cookie-policy/1c6fa428-c368-4247-aaee-4f785cb6b8ac"
        >
          Cookie Policy
        </Link>
        <Link
          onClick={handleModal}
          title="acceptable"
          target="_blank"
          to="https://app.termly.io/document/acceptable-use/5e675ebf-ce69-4322-b7e4-c0840446e50d"
        >
          Acceptable Use Policy
        </Link>
        <Link
          onClick={handleModal}
          title="disclamer"
          target="_blank"
          to="https://app.termly.io/document/disclaimer/87c5ae8c-8b42-4b9f-b0d3-50b743db1bd3"
        >
          Disclaimer
        </Link>
      </div> */}

      <div className="col col-3">
        <h2>Company</h2>

        <Link to="/about" onClick={fns.onMenuClickAbout}>
          About Us
        </Link>

        <p className="query">
          Please send in your queries to <Link>contactus@kamunity.io</Link> to
          learn more
        </p>
      </div>
      <div className="col col-4">
        <h2>Keep me posted</h2>
        <p>
          Be the first to know about the latest updates, news, and promotions
          from Kamunity. We will only send you the most relevant and useful
          information, and you can unsubscribe at any time. Just provide your
          email address below and we'll keep you posted.
        </p>

        <form action="#">
          <svg
            width="22"
            height="17"
            viewBox="0 0 22 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.83334 2.66675L11 10.1667L20.1667 2.66675"
              stroke="#8C97AC"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <rect
              x="1"
              y="1"
              width="20"
              height="15"
              rx="2"
              stroke="#8C97AC"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>

          <input type="text" placeholder="Enter your email" />
          <button>Subscribe</button>
        </form>
      </div>

      <LegalsModal
        isOpen={isModal}
        setIsOpen={setIsModal}
        title={modalInfo.title}
        link={modalInfo.link}
      />
    </div>
  );
};

export default Footer;
